module.exports = __webpack_public_path__ + "img/img_mobile_ui_1.ce81a786.png";